import { Capacitor } from '@capacitor/core'

/**
 * Platform detection utilities for web vs native contexts.
 */

export function isNative() {
  return Capacitor.isNativePlatform()
}

export function isWeb() {
  return !Capacitor.isNativePlatform()
}

export function getPlatform() {
  return Capacitor.getPlatform() // 'web', 'ios', 'android'
}

export function isIOS() {
  return Capacitor.getPlatform() === 'ios'
}

export function isAndroid() {
  return Capacitor.getPlatform() === 'android'
}
